import React, { useState } from 'react'
import { Group, Table, Text } from '@mantine/core'
import { IconArrowNarrowDown, IconArrowNarrowUp, IconFilter, IconFilterFilled } from '@tabler/icons-react'
import { ColumnDef } from './table-helpers'
import { Sort } from '../../../../../../hooks/global-job-matching'
import { FieldFilter } from '../../../../../../constants/filter-operators'

type TableHeaderProps = {
  column: ColumnDef
  handleSort: (column: ColumnDef) => void
  sort: Sort
  filters: FieldFilter[]
  pl?: string | number
  handleFilterClick: (e: React.MouseEvent<SVGSVGElement, MouseEvent>, col: ColumnDef) => void
}

export const TableHeader = ({ column, sort, pl = 0, handleSort, filters, handleFilterClick }: TableHeaderProps) => {
  const columnHasFilter = !!filters.find(f => f.sourceField === column.fieldCode)
  const [hovered, setHovered] = useState(false)
  return (
    <Table.Th w={column.w ?? 150} pl={pl} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onClick={() => handleSort(column)}>
      <Group gap={2} align='center' wrap='nowrap'>
        <Text style={{ fontSize: 12, fontWeight: 500, whiteSpace: 'nowrap', cursor: 'pointer' }}>{column.label}</Text>
        { sort.field === column?.fieldCode && !column.disableSort &&
          <>
            { sort.direction === 'asc' ?
              <IconArrowNarrowDown color='darkGrey' size='14'  /> :
              <IconArrowNarrowUp color='darkGrey' size='14' />
            }
          </>
        }
        { !column.disableSort &&
          <>
            { columnHasFilter ?
              <IconFilterFilled style={{ cursor: 'pointer' }} color='#1467e8' size='14' onClick={(e) => handleFilterClick(e, column)} /> :
              <IconFilter style={{ cursor: 'pointer', visibility: hovered ? 'visible' : 'hidden' }} color='#1467e8' size='14' onClick={(e) => handleFilterClick(e, column)} />
            }
          </>
        }
      </Group>
    </Table.Th>
  )
}
